import { z } from 'zod';
import { LocalizedTextSchema } from './catalog';
/**
 * Gift for the booking amount (owner, 15.10.2026, idea of Maria): the more the customer books,
 * the wider the choice of a free gift. Gifts take no therapist time — something to take home
 * (face mask, hand mask) or LED therapy that runs on its own. The amount counts the ordered
 * treatments and extras only (not retail products), before any discount.
 */
export const BookingGiftOptionSchema = z.object({
    id: z.string().regex(/^[a-z0-9-]{1,40}$/),
    title: LocalizedTextSchema,
    /** Minimum amount of ordered treatments + extras, in cents. */
    minServicesMinor: z.number().int().nonnegative(),
    /** Taken home (true) or done in the studio without the therapist (false, e.g. LED). */
    takeHome: z.boolean(),
});
export const GiftIdSchema = z.string().regex(/^[a-z0-9-]{1,40}$/);
/** Gifts the customer may choose for this amount. */
export function eligibleGifts(options, servicesMinor) {
    return options.filter((o) => servicesMinor >= o.minServicesMinor);
}
/** The next amount that unlocks more gifts, and how much is missing (for "add X € for a gift"). */
export function nextGiftStep(options, servicesMinor) {
    const higher = [...new Set(options.map((o) => o.minServicesMinor))]
        .filter((m) => m > servicesMinor)
        .sort((a, b) => a - b);
    const at = higher[0];
    if (at === undefined)
        return undefined;
    return { atMinor: at, missingMinor: at - servicesMinor, gifts: options.filter((o) => o.minServicesMinor === at) };
}
/** Amount that counts for the gift: ordered treatments and extras (unit price × ordered). */
export function giftBaseMinor(lines) {
    return lines
        .filter((l) => l.kind === 'service' || l.kind === 'addon')
        .reduce((sum, l) => sum + l.unitPriceMinor * l.ordered, 0);
}
//# sourceMappingURL=booking-gift.js.map